module.exports = __webpack_public_path__ + "img/mailBg.f3ff35ac.jpg";